import { render, staticRenderFns } from "./BaaMedcurityAssociates.vue?vue&type=template&id=a802cf5e&scoped=true&"
import script from "./BaaMedcurityAssociates.vue?vue&type=script&lang=js&"
export * from "./BaaMedcurityAssociates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a802cf5e",
  null
  
)

export default component.exports